import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from '../../providers/user-data';
import { CommonData } from '../../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";
import { ToastController } from 'ionic-angular';
@Injectable()
export class EmployeeavalabilityData {
  data: any;
  activeSlots: any;
  timeSlots: any;
  viewmode:string;
  updateRequired:boolean;
  constructor(public http: Http
            , public common: CommonData
            , public userData: UserData
            , public toastCtrl: ToastController
            ) {
              this.timeSlots = [];
              this.activeSlots = [];          
            }
  clear(){
    this.data.length = 0;
    this.activeSlots.length = 0;
  }
  load() {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        this.loadTimeSlots();
        this.http.get(this.common.baseurl+'employeeavailabilities/view?&token='+this.userData.jwt).subscribe(res => {
          
          this.data = res.json().data;
          
          for(let i=0; i<this.data.length; i++){
            this.data[i].t1 = (this.data[i].t1==1);
            this.data[i].t2 = (this.data[i].t2==1);
            this.data[i].t3 = (this.data[i].t3==1);
            this.data[i].t4 = (this.data[i].t4==1);
            this.data[i].t5 = (this.data[i].t5==1);
            this.data[i].t6 = (this.data[i].t6==1);
            this.data[i].t7 = (this.data[i].t7==1);
            this.data[i].t8 = (this.data[i].t8==1);
          }

          this.updateRequired = false;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer employeeavailabilities-data.ts');
          console.log(error);
      });

      }
    });
  }

  loadTimeSlots() {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        this.http.get(this.common.baseurl+'employeeavailabilities/timeslots?&token='+this.userData.jwt).subscribe(res => {
          this.timeSlots = res.json().data;
          this.activeSlots.length = 0;
          //console.log(this.timeSlots);
          for(let i=0; i<this.timeSlots.length; i++){
            if(this.timeSlots[i]!= ''){
              this.activeSlots.push(this.timeSlots[i]);
            }
          }
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer employeeavailabilities-data.ts');
          console.log(error);
      });

      }
    });
  }


  update(ea){
    return new Promise(resolve => {
      ea.t1 = ea.t1 ? 1 : 0;
      ea.t2 = ea.t2 ? 1 : 0;
      ea.t3 = ea.t3 ? 1 : 0;
      ea.t4 = ea.t4 ? 1 : 0;

      var data = JSON.stringify({
        ea: ea,
        token: this.userData.jwt
    });
      this.http.post(this.common.baseurl+'employeeavailabilities/update',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          //console.log(response);

          if(response.success === true){
            if(response.data.status==3){
              let toast = this.toastCtrl.create({
                message: response.message,
                position: 'top',
                cssClass: 'toast-error',
                duration: 3000
              });
              toast.present();                  
            }
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Aktualisieren',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
                  
            //console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });
  }
  createEaEntries(data){
    return new Promise(resolve => {

      this.http.post(this.common.baseurl+'employeeavailabilities/createeaentries',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;


          if(response.success === true){
            this.updateRequired = true;


          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Aktualisieren',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
                  
            //console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });
  }
  closePeriod(data){
    return new Promise(resolve => {

      this.http.post(this.common.baseurl+'employeeavailabilities/closeperiod',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;

          if(response.success === true){
            this.updateRequired = true;
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Aktualisieren',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
                  
            //console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });
  }  

  isActiveSlot(slotnumber){
    if(this.timeSlots.length < slotnumber){
      //console.log("notactive:"+slotnumber);
      return false;
    }
    if(this.timeSlots[slotnumber-1] == ""){
      //console.log("notactive2:"+slotnumber);
      return false;
    }
    return true;
  }
  
  
}



// WEBPACK FOOTER //
// ./src/pages/employeeavailability/employeeavailability-data.ts